import { motion } from "framer-motion";

export const FeatureCard = ({ feature, index }) => {
  const Icon = feature.icon;
  return (
    <motion.div
      initial={{ opacity: 0, y: 26 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 1.15 + index * 0.1, ease: [0.22, 1, 0.36, 1] }}
      className="feature-card group"
      data-testid={`hero-feature-${feature.id}`}
    >
      <div className="feature-icon">
        <Icon className="h-6 w-6" />
      </div>
      <h3 className="mt-3 font-display text-[0.7rem] font-bold tracking-wider text-white sm:text-[0.74rem]">{feature.title}</h3>
      <p className="mt-1 font-body text-sm font-medium leading-snug text-white/65">{feature.desc}</p>
    </motion.div>
  );
};
